angular.module('picmonic-common').directive('uiTab', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<a class="ui-tab text-center light" ng-transclude></a>',
    link: function (scope, element, attrs) {
      element.css({
        'z-index': element.parent().find('.ui-tab').length - element.index(),
      });
      if (element.index() == 0) {
        element.addClass('first');
      } else if (element.index() == element.parent().find('.ui-tab').length - 1) {
        element.addClass('last');
      }
    },
  };
});
